import { TableColumnPopupType } from "../../../Constants/Constants";
import { getLocalisedText } from "../../../Translate/LanguageManager";
import { getSortedHeader } from "../../dktable/TableUtility";

export class ShippingLabelTableItem {
    delivery: string;
    carrier: string;
    numberOfCarton: number;
    weight: string;
    boxHeight: string;
    boxWidth: string;
    boxLength: string;
    trackingNumber: string;
    rawItemValue: any;
    constructor(shippingLabelItem: any, data:any, currency: string) {
        this.delivery = shippingLabelItem.delivery ? shippingLabelItem.delivery : ''
        this.carrier = shippingLabelItem.carrier ? shippingLabelItem.carrier : ''
        this.numberOfCarton = shippingLabelItem.numberOfCarton ? shippingLabelItem.numberOfCarton.toString() : '0'
        this.weight = shippingLabelItem.weight ? shippingLabelItem.weight : ''
        this.boxHeight = shippingLabelItem.boxHeight !== undefined && shippingLabelItem.boxHeight !== null ? shippingLabelItem.boxHeight.toString() : ''
        this.boxWidth = shippingLabelItem.boxWidth !== undefined && shippingLabelItem.boxWidth !== null ? shippingLabelItem.boxWidth.toString() : ''
        this.boxLength = shippingLabelItem.boxLength !== undefined && shippingLabelItem.boxLength !== null ? shippingLabelItem.boxLength.toString() : ''
        this.trackingNumber = shippingLabelItem.trackingNumber ? shippingLabelItem.trackingNumber : ''
        this.rawItemValue = shippingLabelItem
    }

    toString(tableConfig?: any) {
        var sortedHeader = getSortedHeader(tableConfig);
        if (sortedHeader.length > 0) {
            var sortedValue: string[] = []
            sortedHeader.forEach(element => {
                sortedValue.push(this.getValueByType(element.type))
            });
            return sortedValue
        }
        return this.getDefaultList()
    }

    getValueByType(type: string) {
        switch (type) {
            case TableColumnPopupType.delivery:
                return getLocalisedText(this.delivery)
            case TableColumnPopupType.carrier:
                return getLocalisedText(this.carrier)
            case TableColumnPopupType.numberOfCarton:
                return this.numberOfCarton
            case TableColumnPopupType.weight:
                return this.weight
            case TableColumnPopupType.boxHeight:
                return this.boxHeight
            case TableColumnPopupType.boxWidth:
                return this.boxWidth
            case TableColumnPopupType.boxLength:
                return this.boxLength
            case TableColumnPopupType.trackingNumber:
                return this.trackingNumber
            default:
                return ''
        }
    }

    getDefaultList() {
        return [
            getLocalisedText(this.delivery),
            getLocalisedText(this.carrier),
            this.numberOfCarton,
            this.weight,
            this.boxHeight,
            this.boxWidth,
            this.boxLength,
            this.trackingNumber,
        ]
    }
}
